var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"number"},domProps:{"value":Number((this.value * 100).toFixed(2))},on:{"input":function($event){return _vm.$emit('change', $event.target.value / 100)}}})}
var staticRenderFns = []

export { render, staticRenderFns }